function toggleImageLink(event) {
    if (dragging) return;

    let target = event.target.closest(".slab.image-link-grid .wrapper .imageLink .toggle");
    if (target) {
        event.preventDefault();
        event.stopPropagation();
        
        let imageLink = target.closest(".imageLink");
        imageLink.classList.toggle("active");
    }
}

document.addEventListener("click", toggleImageLink);
document.addEventListener("touchend", toggleImageLink);